var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.256 24.776"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.24 1h22.776a2.855 2.855 0 0 1 2.847 2.847v17.082a2.855 2.855 0 0 1-2.847 2.847H4.24a2.855 2.855 0 0 1-2.847-2.847V3.847A2.855 2.855 0 0 1 4.24 1"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29.863 3.847-14.235 9.965L1.393 3.847"
}))));
export default SvgMail;